import type { IconButtonSize, IconButtonTone } from './IconButton';
import { cx } from './cx';

/** The class list of an IconButton look. */
export function iconButtonClasses({
  size = 'md',
  tone = 'default',
  loading = false,
  className,
}: {
  size?: IconButtonSize;
  tone?: IconButtonTone;
  loading?: boolean;
  className?: string;
}) {
  return cx(
    'ee-icon-button',
    `ee-icon-button--${size}`,
    `ee-icon-button--${tone}`,
    loading && 'ee-icon-button--loading',
    className,
  );
}
